import { render, staticRenderFns } from "./ListCommentsList.vue?vue&type=template&id=ef4ec688&"
import script from "./ListCommentsList.vue?vue&type=script&lang=js&"
export * from "./ListCommentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports